<template>
  <div class="order-signing">
    <OrderFilter :type.sync="type" @updateFilter="updateFilter" />
    <OrderSigningDetail
      :type.sync="type"
      :search.sync="search"
    />
  </div>
</template>
<script>
import OrderFilter from '@/components/order/OrderFilter.vue'
import OrderSigningDetail from '@/components/order/OrderSigningDetail.vue'
export default {
  name: 'OrderSigning',
  components: {
    OrderFilter,
    OrderSigningDetail
  },
  data() {
    return {
      type: 'singing',
      search: {
        p: 1,
        limit: 10,
        shop_id: '0',
        time_type: 'create_time',
        begin_time: '',
        end_time: '',
        order_id: '',
        refund_id: '',
        sub_name: '',
        relation_id: '',
        order_type: '',
        kpi_status: '',
        status: '',
        payment: ''
      }
    }
  },
  created() {
    const date = new Date()
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    this.search.begin_time = year + '-' + date.getMonth() + '-' + day
    this.search.end_time = year + '-' + month + '-' + day
  },
  methods: {
    updateFilter(val) {
      this.search = val
    }
  }
}
</script>
<style lang="scss"></style>
